<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} quảng cáo</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} quảng cáo</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} quảng cáo</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
        <b-row>
          <b-col md="9">
            <b-row>
              <b-col md="4">
                <el-form-item label="Tên người đăng ký" prop="thong_tin.ten">
                <el-input
                  v-model="mData.dataForm.thong_tin.ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item label="Tên công ty" prop="thong_tin.ten_cong_ty">
                <el-input
                  v-model="mData.dataForm.thong_tin.ten_cong_ty"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
              </b-col>
              <b-col md="4">
              <el-form-item label="Số điện thoại" prop="thong_tin.sdt">
                <el-input
                  v-model="mData.dataForm.thong_tin.sdt"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-form-item label="Email" prop="thong_tin.email">
                  <el-input
                    v-model="mData.dataForm.thong_tin.email"
                    :disabled="mData.viewMode == 'detail'"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
              <el-form-item label="Ngành nghề" prop="thong_tin.nganh_nghe">
                <el-input
                  v-model="mData.dataForm.thong_tin.nganh_nghe"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item label="Sản phẩm chính" prop="thong_tin.san_pham_chinh">
                  <el-input
                    v-model="mData.dataForm.thong_tin.san_pham_chinh"
                    :disabled="mData.viewMode == 'detail'"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
              <el-form-item
                label="Thời điểm bắt đầu"
                prop="thoi_diem_bat_dau"
              :error="fn_validateTimeStartBeforeTimeEnd()"
              >
                <el-date-picker
                  v-model="mData.dataForm.thoi_diem_bat_dau"
                  :disabled="mData.viewMode == 'detail'"
                  @change="fn_validateTimeStartBeforeTimeEnd()"
                  format="dd/MM/yyyy"
                  ref="startDate"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item
                label="Thời điểm kết thúc"
                prop="thoi_diem_ket_thuc"
                :error="fn_validateTimeStartBeforeTimeEnd()"
              >
                <el-date-picker
                  v-model="mData.dataForm.thoi_diem_ket_thuc"
                  :disabled="mData.viewMode == 'detail'"
                  @change="fn_validateTimeStartBeforeTimeEnd()"
                  format="dd/MM/yyyy"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Trạng thái" prop="trang_thai">
                <el-select
                  v-model="mData.dataForm.trang_thai"
                  :placeholder="aLang.c_select"
                  disabled
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listTrangThai"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Hiển thị" prop="hien_thi">
                <el-select
                  v-model="mData.dataForm.hien_thi"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listHienThi"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                </el-form-item>
              </b-col>
                <b-col md="4" >
                  <el-form-item label="Màn hình hiển thị" prop="vi_tri.trang">
                    <el-select
                    @change="changePage(mData.dataForm.vi_tri.trang)"
                    v-model="mData.dataForm.vi_tri.trang"
                    :placeholder="aLang.c_select"
                    :disabled="mData.viewMode == 'detail'"
                    clearable
                    filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listTrang"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="8" v-if="mData.ifHavePermission">
                  <el-form-item label="Vị trí quảng cáo trên trang" prop="vi_tri.vi_tri_trang">
                    <el-radio-group
                      v-model="mData.dataForm.vi_tri.vi_tri_trang"
                      :disabled="mData.viewMode == 'detail'"
                      >
                      <el-radio
                        label="ViTri1"
                      >     Vị trí 1
                      </el-radio>
                      <el-radio
                        label="ViTri2"
                      >     Vị trí 2
                      </el-radio>
                      <el-radio
                        label="ViTri3"
                        v-if="mData.ifDisable3 != true"
                      >     Vị trí 3
                      </el-radio>
                      <el-radio
                        label="ViTri4"
                        v-if="mData.ifDisable4 != true"
                      >     Vị trí 4
                      </el-radio>
                      <el-radio
                        label="ViTri5"
                        v-if="mData.ifDisable5 != true"
                      >     Vị trí 5
                      </el-radio>
                      <el-radio
                        label="ViTri6"
                        v-if="mData.ifDisable6 != true"
                      >     Vị trí 6
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </b-col>
              <b-col md="12">
                <el-form-item label="Nội dung" prop="thong_tin.noi_dung">
                  <CknoimgComponent
                    v-model="mData.dataForm.thong_tin.noi_dung"
                    :prop-data-editor-disabled="mData.viewMode == 'detail'"
                    @blur="handleBlur('thong_tin.noi_dung')"
                  ></CknoimgComponent>
                </el-form-item>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="3">
            <el-form-item label="Banner quảng cáo" prop="thong_tin.mediaId">
                <el-upload
                    action
                    :auto-upload="false"
                    list-type="picture-card"
                    :limit="mData.fileUploadOption.AnhDaiDien.limit"
                    :accept="mData.fileUploadOption.AnhDaiDien.accept"
                    :on-change="fn_uploadChangeAnhDaiDien"
                    :on-preview="fn_uploadPreviewAnhDaiDien"
                    :on-remove="fn_uploadRemoveAnhDaiDien"
                    :on-exceed="fn_uploadExceedAnhDaiDien"
                    :disabled="mData.viewMode == 'detail'"
                    :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                    :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog
                    :close-on-click-modal="true"
                    :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                    width="60%"
                    top="51px"
                    title="Chi tiết"
                  >
                    <img
                      width="100%"
                      :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl"
                      alt
                    />
                  </el-dialog>
              </el-form-item>
          </b-col>
        </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import DataService from '@/service/DataService';
import QuangCaoModel from './QuangCaoModel';
import QuangCaoApi from '../../../moduleApi/QuangCaoApi';
import ExtensionService from '@/service/ExtensionService';
import CknoimgComponent from "../../../component/CknoimgComponent";
export default {
  components: {
    CknoimgComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "QuangCao",
        dataDefault: {
          listTrangThai: [
            {
              value: 0,
              label: 'Duyệt'
            },
            {
              value: 1,
              label: 'Chờ duyệt'
            },
            {
              value: 2,
              label: 'Từ chối'
            }
          ],
          listHienThi: DataService.visibleList,
          listTrang: DataService.danhSachTrang,
        },
        dataForm: MethodService.copyObject(QuangCaoModel.dataForm),
        validForm: QuangCaoModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        fileUploadOption: MethodService.copyObject(
          QuangCaoModel.dataFormOther.fileUploadOption
        ),
        ifHavePermission: false,
        ifDisable3: false,
        ifDisable4: false,
        ifDisable5: false,
        ifDisable6: false
      },
    };
  },
  created() {
    // this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (this.mData.dataDefault.tourTimeErrorMessage) {
          window.toastr.warning(this.mData.dataDefault.tourTimeErrorMessage);
          this.$refs["startDate"].focus();
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
          MethodService.stopLadda();
          return false;
        }
        if (valid) {


          let data = MethodService.copyObject(this.mData.dataForm);
          try {
            if (type === "update") {
              data.id = this.$router.currentRoute.params.id;
              await QuangCaoApi.update(data);
             this.fn_go();
            }
          } catch (error) {
            toastr.error(
              `Vị trí đặt quảng cáo đã tồn tại, vui lòng chọn ví trí khác!`
            );
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        QuangCaoModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let quang_cao = await QuangCaoApi.findById(id);
      if (quang_cao.result) {
        if(quang_cao.result.vi_tri == undefined){
          quang_cao.result.vi_tri = {trang: null,vi_tri_trang: null};
        }
        this.mData.dataForm = quang_cao.result;
        if (quang_cao.result.thong_tin.mediaId) {
          let data = {
            id: quang_cao.result.thong_tin.mediaId,
            name: quang_cao.result.thong_tin.mediaId,
            url: ExtensionService.urlImg + quang_cao.result.thong_tin.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
      }
      if(this.mData.dataForm.vi_tri.trang == "TrangChu"){
        this.mData.ifHavePermission = true;
        this.mData.ifDisable3 = true;
        this.mData.ifDisable4 = true;
        this.mData.ifDisable5 = true;
        this.mData.ifDisable6 = true;
      }else if(
        this.mData.dataForm.vi_tri.trang == "GioiThieu" ||
        this.mData.dataForm.vi_tri.trang == "DiemDen" ||
        this.mData.dataForm.vi_tri.trang == "ChiTietDiemDen" ||
        this.mData.dataForm.vi_tri.trang == "Tour" ||
        this.mData.dataForm.vi_tri.trang == "ChiTietTour" ||
        this.mData.dataForm.vi_tri.trang == "LuuTru" ||
        this.mData.dataForm.vi_tri.trang == "ChiTietLuuTru" ||
        this.mData.dataForm.vi_tri.trang == "AmThuc" ||
        this.mData.dataForm.vi_tri.trang == "ChiTietAmThuc" ||
        this.mData.dataForm.vi_tri.trang == "GiaiTri" ||
        this.mData.dataForm.vi_tri.trang == "ChiTietGiaiTri" ||
        this.mData.dataForm.vi_tri.trang == "VeDienTu" ||
        this.mData.dataForm.vi_tri.trang == "ChiTietTinTuc"
      ){
        this.mData.ifHavePermission = true;
        this.mData.ifDisable3 = false;
        this.mData.ifDisable4 = false;
        this.mData.ifDisable5 = true;
        this.mData.ifDisable6 = true;
      }else if(
        this.mData.dataForm.vi_tri.trang == "TinTuc"
      ){
        this.mData.ifHavePermission = true;
        this.mData.ifDisable3 = false;
        this.mData.ifDisable4 = false;
        this.mData.ifDisable5 = false;
        this.mData.ifDisable6 = false;
      }else{
        this.mData.ifHavePermission = false;
      }
    },

    fn_go() {
      this.$router.go(-1);
    },
    changePage(value){
      if(value == "TrangChu"){
        this.mData.dataForm.vi_tri.vi_tri_trang = null;
        this.mData.ifHavePermission = true;
        this.mData.ifDisable3 = true;
        this.mData.ifDisable4 = true;
        this.mData.ifDisable5 = true;
        this.mData.ifDisable6 = true;
      }else if(
        value == "GioiThieu" ||
        value == "DiemDen" ||
        value == "ChiTietDiemDen" ||
        value == "Tour" ||
        value == "ChiTietTour" ||
        value == "LuuTru" ||
        value == "ChiTietLuuTru" ||
        value == "AmThuc" ||
        value == "ChiTietAmThuc" ||
        value == "GiaiTri" ||
        value == "ChiTietGiaiTri" ||
        value == "VeDienTu" ||
        value == "ChiTietTinTuc"
      ){
        this.mData.dataForm.vi_tri.vi_tri_trang = null;
        this.mData.ifHavePermission = true;
        this.mData.ifDisable3 = false;
        this.mData.ifDisable4 = false;
        this.mData.ifDisable5 = true;
        this.mData.ifDisable6 = true;
      }else if(
        value == "TinTuc"
      ){
        this.mData.dataForm.vi_tri.vi_tri_trang = null;
        this.mData.ifHavePermission = true;
        this.mData.ifDisable3 = false;
        this.mData.ifDisable4 = false;
        this.mData.ifDisable5 = false;
        this.mData.ifDisable6 = false;
      }else{
        this.mData.ifHavePermission = false;
      }
    },

    fn_formatterDate(cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },
    fn_validateTimeStartBeforeTimeEnd() {
      let timeStart = this.mData.dataForm.thoi_diem_bat_dau;
      let timeEnd = this.mData.dataForm.thoi_diem_ket_thuc;
      this.mData.dataDefault.tourTimeErrorMessage = "";
      if (timeStart && timeEnd) {
        let tourStartTime = new Date(timeStart).getTime();
        let tourEndTime = new Date(timeEnd).getTime();
        if (tourStartTime >= tourEndTime) {

          this.mData.dataDefault.tourTimeErrorMessage = "Giá trị trường Thời gian bắt đầu cần nhỏ hơn trường Thời gian kết thúc";
          return "";
        }
      }

      return "";
    },
    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.thong_tin.mediaId = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField('thong_tin.mediaId');
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "quangCao")
        .then(res => {
          this.mData.dataForm.thong_tin.mediaId = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField('thong_tin.mediaId');
        })
        .catch(() => {
          this.$refs["myForm"].validateField('thong_tin.mediaId');
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    }
  }
}
</script>

<style scoped>
  .el-radio{
    margin-right: 10px;
  }
</style>
